import { render, staticRenderFns } from "./DropsAdditionalInfo.vue?vue&type=template&id=2b16b667&"
import script from "./DropsAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./DropsAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports